// extracted by mini-css-extract-plugin
export default {"currentDayInfo":"currentdayinfo_currentDayInfo__EoLwD","totalTime":"currentdayinfo_totalTime__RahvR","pomodoroCount":"currentdayinfo_pomodoroCount__goGoN"};